import { useGetAllAssignmentCumulativeReportMutation, useGetClassNameMutation, useGetSessionReportOptionsMutation } from '../../../../../../features/authentication/reportApiSlice';
import { useReportContext } from '../../../../../reports/components/reportContext';
import { useParams } from 'react-router-dom';
import QuestionBreakdownReport from './QuestionsBreakdownReport';
import { useEffect, useState } from 'react';
import moment from 'moment/moment';

const AssignmentCumilativeReport = () => {
  const [getCumulativeAssignmentReport] = useGetAllAssignmentCumulativeReportMutation();
  const [getSessionReportOptions] = useGetSessionReportOptionsMutation();
  const [getClassName] = useGetClassNameMutation();
  const [reportTitle, setReportTitle] = useState('Cumulative Class Report');
  const { Id, courseId } = useParams();
  const reportContext = useReportContext();
  reportContext.setSelectedClassId(Id);
  reportContext.setSelectedCourseId(courseId);
  reportContext.setIsAllReport(true);

  useEffect(() => {
    getReportTitle();
    getReportOptions();
  }, []);

  const getReportTitle = async () => {
    if (reportContext?.className) {
      setReportTitle(`Cumulative Class Report for ${reportContext.className}`);
    }
    else {
      try {
        const className = await getClassName(Id).unwrap();
        reportContext.setClassName(className);
        setReportTitle(`Cumulative Class Report for ${className}`);
      } catch {
        setReportTitle('Cumulative Class Report');
      }
    }
  };

  const getReportOptions = async () => {
    const reportOption = {
      reportOptionType: 1
    };

    try {
      const reportResponse = await getSessionReportOptions(reportOption).unwrap();
      reportContext.setStartDate(moment(reportResponse.fromDate).format('yyyy-MM-DD'));
      reportContext.setEndDate(moment(reportResponse.toDate).format('yyyy-MM-DD'));
    } catch {
      reportContext.setEndDate(moment(new Date()).format('yyyy-MM-DD'));
      var thirtyDaysAgo = new Date();
      reportContext.setStartDate(moment(thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30)).format('yyyy-MM-DD'));
    }
  };

  var headerOptions = {
    reportTitle: reportTitle,
    showClassDropdown: false,
    showTeacherName: true,
    showStudentName: false,
    showClassName: false,
    isAllStudentReport: false,
    showRetryInfo: true,
    showTotalRow: true,
    showReportType: false,
    showIncludedQuestions: true
  };

  var reportOptions = {
    showTimePeriod: true,
    scoringThreshhold: true,
    showRetryScoring: true
  };

  return (
    <>
      {
        reportContext.endDate && reportContext.startDate &&
        <QuestionBreakdownReport
          isRetakeReport={false}
          exportFileName='ClassCumilativeReport'
          reportDataEndpoint={getCumulativeAssignmentReport}
          headerOptions={headerOptions}
          reportOptions={reportOptions}
          isTeacherReport={true}
          goBackOnError={false}
        />
      }
    </>
  );

};

export default AssignmentCumilativeReport;